import { useEffect, DependencyList } from 'react';

export function useDebounceEffect(
    debouncedFn: () => void,
    waitTime: number,
    deps?: DependencyList
) {
    useEffect(() => {
        const t = setTimeout(debouncedFn, waitTime);

        return () => {
            clearTimeout(t);
        };
        // we only want to change on dependency change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
